import React from 'react';
import { Image } from '@mafc/trolly';
import { NowJourneyIcon, useDeliveryHours } from '@mafc/common';
import { Product } from 'network/response/ICart';
import { getImageUrl } from 'utils/image.util';

import * as S from './ProductImage.style';
import OOSTag from '../OOSTag';

const ProductImage: React.FC<{
  product: Product;
  mr: string;
  outOfStock: boolean;
  isNowShipment?: boolean;
}> = ({ product, mr, outOfStock, isNowShipment }) => {
  const { isExpressProduct, name } = product;

  const { isNowUnavailableHour } = useDeliveryHours();
  const shouldShowOOSTag = !(isNowShipment && isNowUnavailableHour);

  return (
    <S.ProductImage mr={mr}>
      <S.ImageWrapper outOfStock={outOfStock}>
        <Image name={name} url={getImageUrl(product)} />
      </S.ImageWrapper>
      {outOfStock && shouldShowOOSTag && (
        <S.OOSTag>
          <OOSTag />
        </S.OOSTag>
      )}
      {isExpressProduct && (
        <S.ExpressNowTag outOfStock={outOfStock}>
          <NowJourneyIcon
            variant="new"
            nowIconProps={{ testid: 'ExpressNowNew', height: '20px', width: '55px' }}
          />
        </S.ExpressNowTag>
      )}
    </S.ProductImage>
  );
};

export default ProductImage;
